import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgLoading() {
  return _jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, {
    children: [_jsxs("linearGradient", Object.assign({
      id: "Loading_svg__b",
      gradientUnits: "userSpaceOnUse",
      x1: 16,
      y1: 3,
      x2: 16,
      y2: 22
    }, {
      children: [_jsx("stop", {
        offset: 0,
        stopColor: "currentColor"
      }, void 0), _jsx("stop", {
        offset: 1,
        stopColor: "currentColor",
        stopOpacity: 0.4
      }, void 0)]
    }), void 0), _jsx("path", {
      d: "M12 20a8 8 0 005.694-13.619 1 1 0 011.424-1.405A9.971 9.971 0 0122 12c0 5.523-4.477 10-10 10v-2z",
      fill: "url(#Loading_svg__a)"
    }, void 0), _jsxs("linearGradient", Object.assign({
      id: "Loading_svg__a",
      gradientUnits: "userSpaceOnUse",
      x1: 6,
      y1: 0,
      x2: 6,
      y2: 22
    }, {
      children: [_jsx("stop", {
        offset: 0,
        stopColor: "currentColor",
        stopOpacity: 0
      }, void 0), _jsx("stop", {
        offset: 1,
        stopColor: "currentColor",
        stopOpacity: 0.4
      }, void 0)]
    }), void 0), _jsx("path", {
      d: "M12 4a8 8 0 100 16v2C6.477 22 2 17.523 2 12S6.477 2 12 2v2z",
      fill: "url(#Loading_svg__b)"
    }, void 0), _jsx("circle", {
      cx: 12,
      cy: 3,
      r: 1,
      fill: "currentColor"
    }, void 0)]
  }), void 0);
}

export default SvgLoading;